<template>
  <div class="equipment">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="代理商" label-width="60px">
        <DicInput @fieldId="fieldId($event,'operatorId')" :initName="searchForm.operatorId" :dicType="6"></DicInput>
      </el-form-item>
      <el-form-item label="药房">
        <DicInput @fieldId="fieldId($event,'pharmacyId')" :initName="searchForm.pharmacyId" :dicType="8"></DicInput>
      </el-form-item>
      <el-form-item label="设备类型">
        <DicInput @fieldId="fieldId($event,'deviceTypeId')" :initName="searchForm.deviceTypeId" :dicType="1"></DicInput>
      </el-form-item>
      <el-form-item label="设备编码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="设备状态">
        <el-select v-model="searchForm.status" placeholder="请选择">
          <el-option
              label="未激活"
              value="0">
          </el-option>
          <el-option
              label="未分配保养计划"
              value="1">
          </el-option>
          <el-option
              label="已分配保养计划"
              value="2">
          </el-option>
          <el-option
              label="已退回"
              value="3">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下次维护">
        <el-input style="width: 140px;margin-right: 5px" @input="search" clearable v-model="searchForm.next"
                  placeholder="请输入"></el-input>
        天以内
      </el-form-item>
      <el-form-item label="工人">
        <DicInput @fieldId="fieldId($event,'NextMainTianBy')" :url="'api/Worker/Workers'"
                  :initName="searchForm.NextMainTianBy"></DicInput>
      </el-form-item>
      <el-form-item label="已有维护工人" prop="userName" label-width="120px">
        <el-select v-model="searchForm.isarraged" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="设备名称">
        </el-table-column>
        <el-table-column
            prop="clientId"
            label="设备编号">
        </el-table-column>
        <el-table-column
            prop="modelName"
            label="型号"
            align="center">
        </el-table-column>
        <el-table-column
            prop="nextMaintainWorkerName"
            label="下次保养人"
            align="center">
        </el-table-column>
        <el-table-column
            width="150"
            prop="lastConnectTime"
            label="上次连接"
            align="center">
        </el-table-column>
        <el-table-column
            prop="pharmacyName"
            label="药房"
            align="center">
        </el-table-column>
        <el-table-column
            prop="userName"
            label="用户名"
            align="center">
        </el-table-column>
        <el-table-column
            prop="isOnline"
            label="是否在线"
            align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.isOnline ? '在线' : '不在线' }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="isWork"
            label="工作状态"
            align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.isWork ? '工作' : '待机' }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="nextMaintainTime"
            label="下次维护日期"
            align="center">
        </el-table-column>
        <el-table-column
            prop="note"
            label="备注"
            align="center">
        </el-table-column>
        <!--        <el-table-column-->
        <!--            prop="pharmacyCode"-->
        <!--            label="药房编码"-->
        <!--            align="center">-->
        <!--        </el-table-column>-->
        <el-table-column
            prop="address"
            fixed="right"
            width="260"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" v-if="scope.row.status===0" @click="activationClick(scope.row)">激活
            </el-button>
            <el-button type="text" size="medium" v-if="scope.row.status!==0" @click="restoreClick(scope.row)">恢复出厂
            </el-button>
            <el-button type="text" size="medium" v-if="scope.row.status==2||scope.row.status==1" @click="returnClick(scope.row)">退货
            </el-button>
            <el-button type="text" size="medium" v-if="scope.row.status===1" @click="initKeep(scope.row)">初始化保养
            </el-button>
            <el-button type="text" size="medium" v-if="scope.row.status===2" @click="lookClick(scope.row.id)">维护记录
            </el-button>
            <el-button type="text" size="medium" v-if="scope.row.status===2" @click="DistributionClick(scope.row)">
              分配工人
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="设备名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="设备编号" required>
          <el-input v-model="ruleForm.clientId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="型号" required>
          <DicInput style="width: 100%" :defaultName="ruleForm.modelName" :initName="ruleForm.modelName"
                    @fieldId="ruleFormFieldId($event,'deviceTypeId')" :dicType="1"></DicInput>
        </el-form-item>
        <!--        <el-form-item label="药房">-->
        <!--          <DicInput style="width: 100%" :defaultName="ruleForm.pharmacyName" :initName="ruleForm.pharmacyId" @fieldId="ruleFormFieldId($event,'pharmacyId')" :dicType="8"></DicInput>-->
        <!--        </el-form-item>-->
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="ruleForm.userName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="ruleForm.password" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="阿里云编号">
          <el-input v-model="ruleForm.yunClientId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.note" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="激活设备"
        :close-on-click-modal="false"
        :visible.sync="activationdialog"
        width="30%">
      <el-form :model="activation" ref="activation" label-width="110px" class="demo-ruleForm">
        <el-form-item label="下次维护日期" required>
          <el-date-picker
              v-model="activation.nextMaintainTime"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="药房名称" required>
          <DicInput style="width: 100%" :defaultName="activation.pharmacyName" :initName="activation.pharmacyName"
                    @fieldId="activationFieldId($event,'pharmacyId')" :dicType="8"></DicInput>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="activationdialog = false">取 消</el-button>
    <el-button type="primary" @click="activationForm('activation')">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog width="20%" :close-on-click-modal="false" title="初始化保养计划" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="保养开始日期">
          <el-date-picker
              v-model="form.nextMaintainTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="MaintainForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="分配工人"
        :close-on-click-modal="false"
        :visible.sync="workersDialog"
        width="20%">
      <el-form :model="workerForm" ref="workerForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="工人姓名" required>
          <DicInput style="width: 100%" :initName="workerForm.nextMaintainWorkerName"
                    @fieldId="workersFormfieldId($event,'nextMainTianBy')"
                    :url="'api/Worker/Workers'"></DicInput>
        </el-form-item>
        <el-form-item label="工人电话" required>
          <el-input clearable v-model="workerForm.workerPhone" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="workersDialog = false">取 消</el-button>
    <el-button type="primary" @click="workersForm('workerForm')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import DicInput from "@/components/DicInput";

export default {
  name: "equipment",
  data() {
    return {
      tableData: [],
      searchForm: {
        next: '',
        operatorId: '',
        pharmacyId: '',
        deviceTypeId: '',
        code: '',
        status: ''
      },
      form: {
        nextMaintainTime: ''
      },
      modelTitle: '新增设备',
      dialogVisible: false,
      activationdialog: false,
      dialogFormVisible: false,
      workersDialog: false,
      workersId: '',
      ruleForm: {
        userName: '',
        password: '',
        name: '',
        modelName: '',
        pharmacyName: '',
        deviceTypeId: null,
        pharmacyId: null,
      },
      workerForm: {
        "nextMaintainWorkerName": "",
        "nextMaintainWorkNumber": "",
        "nextMainTianBy": 0,
        "workerPhone": ""
      },
      activation: {
        nextMaintainTime: '',
        pharmacyCode: '',
        pharmacyName: '',
        pharmacyId: '',
      },
      rules: {
        userName: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入设备名称', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ]
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      activationID: '', //每页条数
      PutDeviceMaintainInitID: ''
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        operatorId: '',
        pharmacyId: '',
        deviceTypeId: '',
        code: '',
        NextMainTianBy: '',
        status: ''
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    fieldId(item, name) { // 字典
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    workersFormfieldId(item, name) {
      if (item.id) {
        this.workerForm[name] = item.id
        this.workerForm.nextMaintainWorkerName = item.name
        this.workerForm.nextMaintainWorkNumber = item.code
        this.workerForm.workerPhone = item.phone
      } else {
        this.workerForm[name] = ''
      }
    },
    ruleFormFieldId(item, name) { // 字典
      if (item.id) {
        if (name === 'deviceTypeId') {
          this.ruleForm.modelName = item.name
          this.ruleForm.modelNumber = item.code
        } else {
          this.ruleForm.pharmacyName = item.name
          this.ruleForm.pharmacyCode = item.code
        }
        this.ruleForm[name] = item.id
      } else {
        this.ruleForm[name] = ''
      }
    },
    DistributionClick(row) { // 分配工人
      this.workersList = row
      this.workersDialog = true
      this.workerForm = {
        "nextMaintainWorkerName": "",
        "nextMaintainWorkNumber": "",
        "nextMainTianBy": 0,
        "workerPhone": ""
      }
    },
    initKeep(row) {
      this.dialogFormVisible = true
      this.PutDeviceMaintainInitID = row.id
    },
    MaintainForm() {
      this.axios.put('Device/PutDeviceMaintainInit?id=' + this.PutDeviceMaintainInitID + '&nextMaintainTime=' + this.form.nextMaintainTime,).then(res => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.dialogFormVisible = false
        this.init()
      })
    },
    activationFieldId(item, name) { // 字典
      if (item.id) {
        if (name === 'pharmacyId') {
          this.activation.pharmacyName = item.name
          this.activation.pharmacyCode = item.code
        } else {
        }
        this.activation[name] = item.id
      } else {
        this.activation[name] = ''
        this.activation.pharmacyName = ''
        this.activation.pharmacyCode = ''
      }
    },
    addItem() {
      this.modelTitle = '新增设备'
      this.ruleForm = {
        name: '',
        userName: '',
        password: '',
        modelName: '',
        pharmacyName: '',
        deviceTypeId: null,
        pharmacyId: null,
      }
      this.dialogVisible = true
    },
    editorClick(row) {
      this.modelTitle = '编辑设备'
      this.areaId = row.id
      this.ruleForm = {
        ...row
      }
      this.dialogVisible = true
    },
    activationClick(row) { // 设备激活
      this.activation = {
        nextMaintainTime: '',
        pharmacyCode: '',
        pharmacyName: '',
        pharmacyId: '',
      }
      this.activationID = row.id
      this.activationdialog = true
    },
    restoreClick(row) {
      this.axios
          .put("/api/Device/ResetDevice?id=" + row.id,).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.init()
      })
    },
    returnClick(row) {
      this.axios
          .put("/api/Device/ReturnDevice?id=" + row.id,).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.init()
      })
    },
    lookClick(id) { //维护记录
      this.$router.push({
        path: '/platform/deviceMaintain',
        query: {
          deviceId: id
        }
      })
    },
    workersForm(formName) { // 分配工人
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.workerForm
          }
          this.axios
              .put("api/DeviceMaintain/ArrangeMaintainWorker?id=" + this.workersList.id, data).then((res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.$refs[formName].resetFields();
            this.workersDialog = false
            this.init()
          })
        } else
          return false;
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.deviceTypeId) {
            this.$message.error('系统无法查询到该型号');
            return
          }
          let data = {
            ...this.ruleForm,
          }
          if (this.modelTitle === '编辑设备') {
            this.axios
                .put("api/Device?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          } else {
            this.axios
                .post("api/Device", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    // 设备激活弹窗确定
    activationForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.activation.pharmacyId) {
            this.$message.error('系统无法查询到该药房');
            return
          }
          let data = {
            ...this.activation,
          }
          this.axios
              .put("api/Device/PutDeviceActivate?id=" + this.activationID, data).then((res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.$refs[formName].resetFields();
            this.activationdialog = false
            this.init()
          })
        } else {
          return false;
        }
      });
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    // list
    init() {
      let data = {
        ...this.searchForm,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/Device/GetWithPage", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.tableData.forEach(item=>{
              item.lastConnectTime = this.dayjs(item.lastConnectTime).format('YYYY/MM/DD HH:mm:ss') || ' '
              item.nextMaintainTime = this.dayjs(item.nextMaintainTime).format('YYYY/MM/DD') || ' '
            })
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.equipment {

}
</style>